export default "__VITE_ASSET__BGBzu3Zm__"